import { useEffect, useState } from "react";
import {
  utils,
  verificationBuilder,
  openAttestationVerifiers,
  isValid,
} from "@govtechsg/oa-verify";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/solid";
import Viewer from "./Viewer";

import { WrappedDocument } from "@govtechsg/open-attestation/dist/types/2.0/types";

type Document = {
  name: string;
  document: WrappedDocument;
  frameSource: string;
};

interface VerifierProps {
  document: any;
}

const Verifier: React.FC<VerifierProps> = ({ document }) => {
  const [integrity, setIntegrity] = useState<boolean | null>(null);
  const [status, setStatus] = useState<boolean | null>(null);
  const [identity, setIdentity] = useState<boolean | null>(null);
  const [valid, setValid] = useState<boolean | null>(null);
  const [url, setUrl] = useState<string | null>(null);
  const [renderedDoc, setRenderedDoc] = useState<any>();
  const [issuer, setIssuer] = useState<string | null>(null);

  useEffect(() => {
    // const customProvider = utils.generateProvider();
    const verifyDocument = async () => {
      const verify = verificationBuilder(openAttestationVerifiers, {
        network: "matic",
      });
      const fragments = await verify(document as any);
      setIntegrity(isValid(fragments, ["DOCUMENT_INTEGRITY"]));
      setStatus(isValid(fragments, ["DOCUMENT_STATUS"]));
      setIdentity(isValid(fragments, ["ISSUER_IDENTITY"]));
      setValid(isValid(fragments));

      //render document
      //get url
      const urlData = document.data.$template.url;
      const url = urlData.substring(urlData.indexOf("string:") + 7);
      setUrl(url);
      //get name
      const nameData = document.data.$template.name;
      const name = nameData.substring(nameData.indexOf("string:") + 7);
      //get identity
      const issuerData =
        document["data"]["issuers"][0]["identityProof"]["location"];
      const issuer = issuerData.substring(issuerData.indexOf("string:") + 7);
      console.log(issuer);
      setIssuer(issuer);
      const doc: Document = {
        name: name,
        document: document,
        frameSource: url,
      };
      setRenderedDoc(doc);
      console.log(url);
      console.log(name);
    };
    verifyDocument();
  }, [document]);
  if (
    integrity === null ||
    status === null ||
    identity === null ||
    valid === null ||
    issuer === null
  ) {
    return (
      <div className="flex flex-col items-center justify-top min-h-[calc(100vh-5rem)] h-full w-full bg-gradient-to-br from-accent to-primary">
        <span className="loading loading-dots loading-lg mt-80"></span>
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center justify-top min-h-[calc(100vh-5rem)] w-full bg-gradient-to-br from-accent to-primary">
      <div className="grid grid-cols-6 grid-rows-8 gap-4 mt-10 w-full">
        <div className="col-span-6 card bg-base-100 shadow-lg ml-10 mr-10">
          <div className="card-body">
            <p className="text-3xl font-bold">
              This certificate is issued by {issuer}
            </p>
            <p className="text-2xl">
              This certificate is {valid ? "valid" : "invalid"}
            </p>
          </div>
        </div>
        <div className="col-span-2 row-start-2 card bg-base-100 shadow-lg ml-10 mt-5">
          <div className="card-body">
            <div className="flex gap-4">
              {integrity ? (
                <span className="badge bg-success p-3">
                  <CheckIcon className="h-5 w-5" />
                </span>
              ) : (
                <span className="badge bg-error p-3">
                  <XMarkIcon className="h-5 w-5" />
                </span>
              )}
              {integrity ? (
                <p>Document has not been tampered with</p>
              ) : (
                <p>Document has been tampered with</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-span-2 col-start-3 row-start-2 card bg-base-100 shadow-lg ml-10 mt-5">
          <div className="card-body">
            <div className="flex gap-4">
              {status ? (
                <span className="badge bg-success p-3">
                  <CheckIcon className="h-5 w-5" />
                </span>
              ) : (
                <span className="badge bg-error p-3">
                  <XMarkIcon className="h-5 w-5" />
                </span>
              )}
              {status ? (
                <p>Document has been issued</p>
              ) : (
                <p>Document has not been issued</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-span-2 col-start-5 row-start-2 card bg-base-100 shadow-lg ml-10 mt-5 mr-10">
          <div className="card-body">
            <div className="flex gap-4">
              {identity ? (
                <span className="badge bg-success p-3">
                  <CheckIcon className="h-5 w-5" />
                </span>
              ) : (
                <span className="badge bg-error p-3">
                  <XMarkIcon className="h-5 w-5" />
                </span>
              )}
              {identity ? (
                <p>Issuer has been identified</p>
              ) : (
                <p>Issuer has not been identified</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-span-6 row-span-6 row-start-3 card bg-base-100 shadow-lg ml-10 mr-10 mt-5">
          <div className="card-body flex flex-col justify-center items-center">
            <Viewer document={renderedDoc} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verifier;
